<template>
    <el-dialog
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        class="custom_form_dialog custom-form-dialog work_order_finish_form"
        title="工单结单"
        width="520px"
    >
        <div v-loading="loading" class="custom_form_body">
            <el-form
                ref="workOrderFinishForm"
                :model="workOrderFinishForm"
                :rules="workOrderFinishFormRules"
                label-position="top"
                size="small"
            >
                <el-form-item label="日期" prop="end_date">
                    <div class="date_range_apm_wrap">
                        <div class="flex_wrap">
                            <el-date-picker
                                v-model="workOrderFinishForm.start_date"
                                :editable="false"
                                format="yyyy-MM-dd"
                                placeholder="请选择开始时间"
                                type="date"
                                value-format="yyyy-MM-dd"
                                :clearable="false"
                                disabled
                            >
                            </el-date-picker>
                            <span class="line"></span>
                            <el-select v-model="workOrderFinishForm.start_time"  disabled>
                                <el-option :value="1" label="上午"></el-option>
                                <el-option :value="2" label="下午"></el-option>
                            </el-select>
                        </div>
                        <div class="flex_wrap">
                            <el-date-picker
                                v-model="workOrderFinishForm.end_date"
                                :editable="false"
                                format="yyyy-MM-dd"
                                placeholder="请选择结束时间"
                                type="date"
                                value-format="yyyy-MM-dd"
                                :clearable="false"
                                disabled
                            >
                            </el-date-picker>
                            <span class="line"></span>
                            <el-select v-model="workOrderFinishForm.end_time"  disabled>
                                <el-option :value="1" label="上午"></el-option>
                                <el-option :value="2" label="下午"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="date_txt">
                        <span>时长{{ workOrderFinishForm.duration }}天（{{workOrderFinishForm.days}}人日）</span>
                    </div>
                </el-form-item>
                <el-form-item label="实施人" prop="processing_uid">
                    <!-- <div class="select-author-btn" @click="handleChangeUser">
                        <div>
                            <span :class="{ 'text-bold': processingUidData && processingUidData.length }">{{
                                (processingUidData.length && processingUidData[0].name) || "请选择实施人"
                            }}</span>
                        </div>
                        <i class="el-icon-arrow-down"></i>
                    </div> -->
                    <el-select
                        v-model="workOrderFinishForm.processing_uid"
                        filterable
                        multiple
                        placeholder="请选择实施人"
                        size="small"
                        readonly
                        disabled
                    >
                        <el-option
                            v-for="user in processingUidData"
                            :key="user.id"
                            :label="user.name"
                            :value="user.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="实施报告/证明" prop="files" :rules="finishUploadRules">
                    <div class="file_upload_wrap" v-if="workOrderFinishForm.files.length === 0">
                        <div class="file_outer_wrap">
                            <img
                                alt=""
                                src="https://download.hecoos.com/enlightv/2023-31/3wy8ZnscPAjXMD2XmQhb.png"
                                width="36"
                            />
                            <p class="file_hint">点击或者将文件拖拽到这里上传</p>
                            <p class="file_type_hint" v-text="'支持Word、Excel、PDF等常见类型'"></p>
                            <input
                                class="upload_input"
                                multiple
                                type="file"
                                @change="handleUploadFileChange($event, 'files', workOrderFinishForm)"
                            />
                        </div>
                    </div>
                    <ul v-else class="upload_file_list">
                        <li v-for="(file, file_idx) in workOrderFinishForm.files" class="upload_file_item">
                            <div class="file_left_wrap">
                                <img
                                    alt=""
                                    class="file_img"
                                    src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                />
                                <div class="file_info_wrap">
                                    <p class="file_name" v-text="file.file_name"></p>
                                    <p class="file_size" v-text="file.file_size"></p>
                                </div>
                            </div>
                            <div class="file_right_wrap">
                                <el-tooltip content="预览" effect="dark" placement="top">
                                    <span class="handle_icon_wrap" @click="handleClickPreview(file)">
                                        <i class="iconfont icon-yanjing"></i>
                                    </span>
                                </el-tooltip>
                                <span class="line"></span>
                                <el-tooltip content="删除" effect="dark" placement="top">
                                    <span
                                        class="handle_icon_wrap handle_icon_danger_wrap"
                                        @click="workOrderFinishForm.files.splice(file_idx, 1)"
                                    >
                                        <i class="iconfont icon-shanchu1"></i>
                                    </span>
                                </el-tooltip>
                            </div>
                        </li>
                        <li class="upload_file_btn_wrap">
                            <i class="el-icon-plus"></i>
                            <span>上传附件</span>
                            <input
                                class="upload_input"
                                multiple
                                type="file"
                                @change="handleUploadFileChange($event, 'files', workOrderFinishForm)"
                            />
                        </li>
                    </ul>
                </el-form-item>
                <el-form-item label="结单描述" prop="note" :rules="finishContentRules">
                    <el-input
                        v-model="workOrderFinishForm.note"
                        :rows="7"
                        maxlength="500"
                        placeholder="请输入"
                        show-word-limit
                        type="textarea"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div class="add_approval_select_process">
                <div class="page_little_title">
                    <span class="title">审批流程</span>
                </div>
                <approveProcessSelect ref="approveProcessSelectRef" :approval_node_list="approval_node_list">
                </approveProcessSelect>
            </div>
        </div>
        <div slot="footer">
            <el-button @click="handleDialogClose">取消</el-button>
            <el-button type="primary" @click="handleDialogConfirm">确认</el-button>
        </div>
        <el-image ref="preview_img" :preview-src-list="previewImgList" :src="previewImgSrc" style="display: none">
        </el-image>
    </el-dialog>
</template>
<script>
import { workOrderSetDetail, workOrderFinish, getApprovalNodes,  workOrderFinishDetail} from "@/api";
import { formatFileSize, getNowDate } from "@/utils";
import { uploadImg } from "@/utils/uploadOss";
import approveProcessSelect from "@/components/pComponents/approveProcessSelect";
export default {
    name: "WorkOrderFinish",
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        workorder_id: {
            type: Number,
            default: 0,
        },
        workorder_num: {
            type: String,
            default: ""
        },
        finishInfo: {
            type: Object,
            default: {}
        }, // 其它订单、工单信息
    },
    data() {
        return {
            loading: false,
            workOrderFinishForm: {
                start_date: getNowDate(),
                start_time: 1,
                end_date: getNowDate(),
                end_time: 1,
                duration: 0,
                note: "",
                files: [],
                processing_uid: "",
                days: 0
            },
            workOrderFinishFormRules: {
                end_date: [{ required: true, message: "请选择时间", trigger: ["blur", "change"] }]
            },
            is_finish_upload: false,
            is_finish_content: false,

            processingUidData: [],

            previewImgList: [],
            previewImgSrc: "",

            approval_node_list: [],

        };
    },
    computed: {
        finishUploadRules() {
            if(this.is_finish_upload) {
                return [
                    {
                        required: true,
                        message: "请上传实施报告/证明",
                        trigger: ["blur", "change"]
                    }
                ]
            }
            return []
        },
        finishContentRules() {
            if(this.is_finish_content) {
                return [
                {
                        required:true,
                        message: "请填写结单描述",
                        trigger: ["blur", "change"]
                    }
                ]
            }
            return []
        }
    },
    watch: {
        finishUploadRules() {
            this.$refs.workOrderFinishForm && this.$refs.workOrderFinishForm.validateField('files');
        },
        finishContentRules() {
            this.$refs.workOrderFinishForm && this.$refs.workOrderFinishForm.validateField('note');
        }
    },
    components: { approveProcessSelect },
    created() {
        this.getWorkOrderSetDetail();
        this.getApprovalNodesData();
        if (this.workorder_id) {
            this.getworkOrderFinishDetail();
        }
    },
    methods: {
        handleChangeUser() {},
        // 关闭弹窗
        handleDialogClose() {
            this.$emit("update:dialogVisible", false);
        },
        // 获取上传实施报告/证明，填写结单描述
        getWorkOrderSetDetail() {
            this.loading = true;
            workOrderSetDetail()
                .then((res) => {
                    this.is_finish_upload = res.data.is_finish_upload == 1 ? true : false;
                    this.is_finish_content = res.data.is_finish_content  == 1 ? true: false;
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        // 获取数据
        getworkOrderFinishDetail() {
            workOrderFinishDetail({ workorder_id: this.workorder_id }).then((res) => {
                if (res.code === 200) {
                    const data = res.data
                    this.processingUidData = data.processing || []
                    this.workOrderFinishForm.start_date = data.start_date
                    this.workOrderFinishForm.start_time = data.start_time
                    this.workOrderFinishForm.end_date = data.end_date
                    this.workOrderFinishForm.end_time = data.end_time
                    this.workOrderFinishForm.duration = data.duration
                    this.workOrderFinishForm.days = data.days
                    this.workOrderFinishForm.processing_uid = data.processing.map(item=> item.id)
                }
            });
        },
        // 获取审批数据
        getApprovalNodesData() {
            this.loading = true;
            getApprovalNodes({
                approval_type: "workorder_finish",
            })
                .then((res) => {
                    if (res.code === 200) {
                        this.approval_node_list = res.data;
                        this.$refs.approveProcessSelectRef.set_approval_node_list(res.data);
                    } else {
                        this.$message.error(res.message);
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //附件上传事件
        handleUploadFileChange(e, field, formData) {
            const files = e.target.files;
            const that = this;
            Array.from(files).forEach((file) => {
                if (file.size > 1024 * 1024 * 1024) return that.$message.error("附件大小不能超过1G");
                // if (field.file_type && field.file_type.length) {
                //     const fileType = file.name.match(/\.(\w+)$/)[1]; // 获取文件类型的后缀名
                //     if (!field.file_type.includes(fileType.toLowerCase()))
                //         return that.$message.error("上传文件类型不在管理员设置的范围内，请重新上传");
                // }
                uploadImg(file, file.size)
                    .then((res) => {
                        if (res.file_path) {
                            res.file_size = formatFileSize(file.size);
                            formData[field].push(res);
                            e.target.value = "";
                        }
                        e.target.value = "";
                    })
                    .catch((error) => {
                        e.target.value = "";
                    });
            });
        },
        //附件预览事件
        handleClickPreview(file) {
            if (file.file_type.includes("image")) {
                this.previewImgList = [file.file_path];
                this.previewImgSrc = file.file_path;
                this.$refs.preview_img.showViewer = true;
            } else {
                if (file.file_type.includes("pdf")) {
                    window.open(file.file_path);
                } else {
                    this.$message.error("当前文件类型不支持预览");
                }
            }
        },
        // 确定
        handleDialogConfirm() {
            this.$refs.workOrderFinishForm.validate((valid) => {
                if (valid) {
                    if (!this.$refs.approveProcessSelectRef.handleClickPublish()) return false;
                    let start_time = this.workOrderFinishForm.start_time == 1 ? '上午' : '下午'
                    let end_time =   this.workOrderFinishForm.end_time == 1   ? '上午' : '下午'
                    let finish_date = `${this.workOrderFinishForm.start_date} ${start_time} ${this.workOrderFinishForm.end_date} ${end_time}`;
                    const params = {
                        workorder_id: this.workorder_id,
                        workorder_num: this.workorder_num,
                        start_date: this.workOrderFinishForm.start_date,
                        start_time: this.workOrderFinishForm.start_time,
                        end_date: this.workOrderFinishForm.end_date,
                        end_time: this.workOrderFinishForm.end_time,
                        duration: this.workOrderFinishForm.duration,
                        days: this.workOrderFinishForm.days,
                        note: this.workOrderFinishForm.note,
                        files: this.workOrderFinishForm.files,
                        node_list: this.approval_node_list,
                        processing_users: this.processingUidData.map(item=> item.name),
                        finish_date:finish_date,
                        ...this.finishInfo
                    };
                    workOrderFinish(params).then((res) => {
                        if (res.code === 200) {
                            this.$message.success("结单完成");
                            this.$emit("update:dialogVisible", false);
                            this.$emit("refreshList");
                        }
                    });
                }
            });
        },
    },
};
</script>
<style lang="scss">
.work_order_finish_form {
    .select-author-btn {
        width: 100%;
        height: 32px;
        padding: 12px;
        opacity: 1;
        border-radius: 4px;
        background: #ffffff;
        border: 1px solid #d9d9d9;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: rgba(153, 153, 153, 1);
        cursor: pointer;

        .el-icon-arrow-down {
            color: #666666;
        }

        &:active {
            border-color: #409eff;
        }

        .text-bold {
            color: rgba(51, 51, 51, 1);
        }
    }
    .date_range_apm_wrap {
        display: flex;
        align-items: center;
        background-color: #F5F7FA;
        border-radius: 4px;
        border: 1px solid #d9d9d9;
        gap: 8px;

        .flex_wrap {
            flex: 1;
        }
        .flex_wrap_date {
            width: 42px;
            flex: none;
        }

        ::v-deep .el-input__inner {
            border: none;
        }

        ::v-deep .el-date-editor {
            flex: 1;
        }

        ::v-deep .el-select {
            width: 60px;

            .el-input__inner {
                padding: 0;
            }
        }
        .el-input__inner {
            padding: 0 12px;
            border-color: rgb(217, 217, 217);
            border: none;
            color: rgb(51, 51, 51);
            font-size: 14px;
            padding-left: 30px !important;
        }
        .el-select {
            width: 60px !important;
            flex-shrink: 0;
            .el-input__inner {
                padding: 0 !important;
            }
        }
    }
    .date_txt {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 18px;
        color: rgba(153, 153, 153, 1);
    }
}
</style>
